/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

window.addEventListener('load', function () {
    document.querySelector('#mobile-menu-1').setAttribute('open', 'true');
});

/***********************/
// Add Class To Body

document.addEventListener('DOMContentLoaded', function() {
    const cartDrawer = document.querySelector('#mini-cart');
    const body = document.querySelector('body');

    if ($('#mini-cart').attr('open')) {
      body.classList.add('cart-drawer-open');
    } else {
      body.classList.remove('cart-drawer-open');
    }
        
});

  document.addEventListener("DOMContentLoaded", function() {
    const drawer = document.getElementById("drawer-popup");
    const designContainer = document.querySelector(".design-selection-container");

    window.openDrawer = function() {
      drawer.classList.remove("hidden"); // Drawer anzeigen
      designContainer.classList.add("hidden"); // Designs verstecken (und damit den Banner)
    };

    window.closeDrawer = function() {
      drawer.classList.add("hidden"); // Drawer ausblenden
      designContainer.classList.remove("hidden"); // Designs wieder anzeigen
    };

    const designElements = document.querySelectorAll(".color-selection__image--top");
    designElements.forEach(element => {
      element.addEventListener("click", function() {
        openDrawer();
      });
    });
  });

document.addEventListener("DOMContentLoaded", function () {
  let currentPage = 1; // Aktuelle Seite
  let loading = false;
  const maxPages =4; // Maximale Seitenanzahl (z. B. 4 Seiten à 50 Produkte = 200 Produkte insgesamt)

  function loadMoreProducts(button) {
    if (loading) return; // Lade-Sperre aktivieren, um mehrfaches Laden zu verhindern

    loading = true; // Blockiere weiteres Laden
    button.style.display = "none"; // Verstecke den Button während des Ladens

    currentPage++; // Erhöhe die Seitenanzahl
    if (currentPage > maxPages) {
      // Wenn alle Produkte geladen sind, entferne den Button
      button.remove();
      return;
    }

    fetch(`${window.location.pathname}?page=${currentPage}`)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");

        // Finde die neuen Produkte
        const newProducts = doc.querySelectorAll("#facet-main > *");
        if (newProducts.length > 0) {
          const facetMain = document.querySelector("#facet-main");

          // Neue Produkte hinzufügen
          newProducts.forEach((product) => {
            // Verhindere doppelte Produkte (falls `data-id` verfügbar ist)
            if (!facetMain.querySelector(`[data-id="${product.dataset.id}"]`)) {
              facetMain.appendChild(product);
            }
          });

          // Entferne den alten Button und füge ihn unten erneut ein
       document.querySelectorAll(".load-more-container").forEach((container) => {
  container.remove(); // Entferne alle existierenden Button-Container
});


          // Falls weitere Seiten existieren, füge den Button erneut ein
          if (currentPage < maxPages) {
            const newButtonContainer = document.createElement("div");
            newButtonContainer.classList.add("load-more-container");

            const newButton = document.createElement("button");
            newButton.id = "load-more";
            newButton.textContent = "Mehr anzeigen";
            newButton.addEventListener("click", function () {
              loadMoreProducts(newButton);
            });

            newButtonContainer.appendChild(newButton);
            facetMain.appendChild(newButtonContainer); // Neuer Button am Ende
          }
        } else {
          // Keine neuen Produkte -> Button entfernen
          button.remove();
        }

        loading = false; // Lade-Sperre wieder freigeben
      })
      .catch((error) => {
        console.error("Fehler beim Laden der Produkte:", error);
        loading = false; // Lade-Sperre deaktivieren
        button.style.display = "block"; // Zeige den Button wieder an
      });
  }

  // Initialisiere den ersten Mehr-Anzeigen-Button
  const loadMoreButton = document.getElementById("load-more");
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", function () {
      loadMoreProducts(loadMoreButton);
    });
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const button = document.getElementById("floating-add-to-cart");

  window.addEventListener("scroll", function () {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const scrollThreshold = document.documentElement.scrollHeight * 0.3; // 30% der Seite

    if (scrollPosition > scrollThreshold) {
      button.style.display = "block";
    } else {
      button.style.display = "none";
    }
  });

  // Pop-up anzeigen beim Klick auf den Button
  button.addEventListener("click", function () {
    const popup = document.querySelector("#color-selection__selection-container productDrawer"); // Ersetze #popup-id mit der ID oder Klasse des Pop-ups

    if (popup) {
      popup.style.display = "block"; // Oder eine Methode verwenden, die dein Pop-up sichtbar macht
    } else {
      console.warn("Pop-up-Element nicht gefunden!");
    }
  });
});



